import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Tabs from "./Tabs";
import Home from "./Home";
import Physio from "./Physio";
import Ortho from "./Ortho";
import Company from "./Company";
import Footer from "./Footer";
import PrivacyPolicy from "./PrivacyPolicy";

// Placeholder components for the different pages

function App() {
  return (
    <Router>
      {" "}
      <Tabs /> {/* Tabs should be inside Router */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Physio" element={<Physio />} />
        <Route path="/ortho" element={<Ortho />} />
        <Route path="/company" element={<Company />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
      </Routes>
      <Footer/>
    </Router>
    
  );
}

export default App;
